import { render, staticRenderFns } from "./PartsCatalogueItemListView.vue?vue&type=template&id=1df031db"
import script from "./PartsCatalogueItemListView.vue?vue&type=script&lang=js"
export * from "./PartsCatalogueItemListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1df031db')) {
      api.createRecord('1df031db', component.options)
    } else {
      api.reload('1df031db', component.options)
    }
    module.hot.accept("./PartsCatalogueItemListView.vue?vue&type=template&id=1df031db", function () {
      api.rerender('1df031db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/partscatalogue/PartsCatalogueItemListView.vue"
export default component.exports